export const convertServicedeskPathToHelpCenter = (path: string) =>
	path.replace('/jira/servicedesk/', '/jira/helpcenter/');
